import Sleep from '@/lib/sleep'
import {
	faFileExport,
} from '@fortawesome/pro-duotone-svg-icons'
import { Transition } from '@headlessui/react'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import Button from '../ui/Button'
import Input from '../ui/Input'
import Alert from '../ui/Alert'
import CardTitle from '../ui/CardTitle'
import AppsService from '@/services/apps'
import * as Notification from '@/components/ui/Notification'

export default function ExportSessions(props) {
	const [error, setError] = useState(null)
	const { register, handleSubmit, errors } = useForm()
	const [loading, setLoading] = useState(false)
	const [alias, setAlias] = useState('')
	const [session, setSession] = useState('')
	const [app, setApp] = useState('')

	const formSchema = {
		app: {
			required: 'App required',
		},
	}

	const onSubmit = async (data) => {
		setLoading(true)
        setApp(data.app)

		await AppsService.GetAppExport(data.app).then(async (data) => {
			console.log(data)
            let csvContent = 'data:text/csv;charset=utf-8,' + data.map(e => e.join(',')).join('\n')
            let encodedUri = encodeURI(csvContent)
            var link = document.createElement('a')
            link.setAttribute('href', encodedUri)
            link.setAttribute('download', 'export_' + app + '.csv')
            document.body.appendChild(link)
            link.click()
            setLoading(false)
		}).catch((err) => {
			Notification.error(err.message)
			setLoading(false)
		})
	}

	return (
		<Transition
			show={props.open}
			enter="ease-out duration-200"
			enterFrom="opacity-0"
			enterTo="opacity-100"
			leave="ease-in duration-100"
			leaveFrom="opacity-100"
			leaveTo="opacity-0">
			<div className="fixed z-10 inset-0 overflow-y-auto">
				<div className="flex items-end justify-center min-h-screen text-center sm:block sm:p-0">
					<div
						className="fixed inset-0 transition-opacity"
						aria-hidden="true"
						onClick={() => props.onClose()}>
						<div className="absolute inset-0 bg-gray-800 opacity-75"></div>
					</div>

					<span
						className="hidden sm:inline-block sm:align-middle sm:h-screen"
						aria-hidden="true">
						&#8203;
					</span>

					<div
						className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
						role="dialog"
						aria-modal="true"
						aria-labelledby="modal-headline">
						<div className="p-4">
							<div>
								<div>
									<div>
										<CardTitle
											value={'Export app'}
											icon={faFileExport}></CardTitle>
									</div>
								</div>
								<form onSubmit={handleSubmit(onSubmit)}>
										<div>
											<div className="py-2 px-3">
												{error ? (
													<Alert type="error" title={error}></Alert>
												) : null}
											</div>
											<div className="flex flex-wrap">
												<div className="p-3 w-full">
													<Input
														type="text"
														name="app"
														referrer={register(formSchema.app)}
														label={'App Key to export'}
														error={errors.app}
														message={errors.session?.app}
													/>
												</div>
											</div>
										</div>
									
									<div>
										<div className="flex justify-between">
											<div className="p-3"></div>
											<div className="p-3">
												<div className="flex">
													<div className="mr-3">
														<Button
															theme="secondary"
															onClick={() => props.onClose()}
															label="Cancel"
														/>
													</div>
													<div>
														<Button
															type="submit"
															theme="success"
															loading={loading}
															onClick={() => handleSubmit(onSubmit)}
															label={'Export'}
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Transition>
	)
}
